export const BASE_TARGET = process.env.REACT_APP_ENTRYPOINT

export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET

export const APP_VERSION = process.env.REACT_APP_VERSION
